import React from 'react';
import classNames from 'classnames';

import { generateRandomKey } from '../../utils';

import sitemapClasses from '../../css/sitemap.module.css';
import Styles from './JobsByStates.module.css';

const JobsByStates = (props) => {
  const { nofollow, isHomePage, states } = props;

  return (
    <section
      className={classNames('section', Styles['industries-sec'], {
        [sitemapClasses['siteMapTopLevelCareer']]: isHomePage,
      })}
    >
      <div className="container">
        <div className="row no-gutters">
          {isHomePage ? (
            <div className="col-lg-12 main_inner">
              <h2 className="brandonH2 sec-head pr-15">MOST POPULAR JOBS BY STATE</h2>
            </div>
          ) : (
            <div className="col-lg-12">
              <h2 className="sectionTitle brandonH1">MOST POPULAR JOBS BY STATE</h2>
            </div>
          )}
          {states &&
            states.map((state) => (
              <div
                key={generateRandomKey()}
                className="col-md-4ths col-sm-4ths col-md-3 float-left"
              >
                <ul className={`z-p-0 z-m-0 ${sitemapClasses['explorerStates']} explorerStates`}>
                  {state &&
                    state.map((stateOb) => (
                      <li key={stateOb.text} className="d-flex">
                        {nofollow ? (
                          <a className="list-link" rel="nofollow" href={stateOb.link}>
                            {stateOb.text}
                          </a>
                        ) : (
                          <a className="list-link" href={stateOb.link}>
                            {stateOb.text}
                          </a>
                        )}
                      </li>
                    ))}
                </ul>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};
export default JobsByStates;
